"use client";

import { useEffect, useRef } from "react";

import { useSiteDetailDrawer } from "./site-detail-drawer-provider";

export function SiteDetailDrawerUrlSync({
  siteSlug,
}: {
  siteSlug: string | null;
}) {
  const { open } = useSiteDetailDrawer();

  // マウント時の値のみを見る（siteSlug のその後の変化では再オープンしない）。
  const initialSiteSlugRef = useRef(siteSlug);
  useEffect(() => {
    const initialSiteSlug = initialSiteSlugRef.current;
    if (initialSiteSlug) open({ siteSlug: initialSiteSlug });
  }, [open]);

  return null;
}
